import React from "react";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import { useTranslations } from "@jugl-web/utils";
import { CRMAccountTile } from "../CRMAccountTile";
import { ManageAccountsDrawerScreenToParametersMap } from "../../types";
import { ReactComponent as TwilioIcon } from "./assets/twilio.svg";
import { ReactComponent as LinkIcon } from "./assets/link.svg";
import { ReactComponent as MessageIcon } from "./assets/message.svg";
import { ReactComponent as PhoneIcon } from "./assets/phone.svg";
import { ReactComponent as SettingsIcon } from "./assets/settings.svg";
import { ReactComponent as TwilioBrandIcon } from "./assets/twilio-brand.svg";
import { useManageAccountsDrawer } from "../../providers/ManageAccountsDrawerContext";

export const TwilioAccountCard: React.FC<{
  isClickable?: boolean;
}> = ({ isClickable }) => {
  const { t } = useTranslations();
  const { transitionTo } =
    useScreenTransitionManager<ManageAccountsDrawerScreenToParametersMap>();

  const { crmConfig } = useManageAccountsDrawer();

  const config = crmConfig?.twilio;

  const handleClick = () => {
    if (!isClickable) {
      return;
    }
    transitionTo({ name: "twilioAccount" });
  };

  return (
    <CRMAccountTile
      isClickable={isClickable}
      title={t({
        id: "client-support-page.sms-chat",
        defaultMessage: "SMS Chat",
      })}
      isConnected={!!config?.id}
      onClick={handleClick}
      icon={<TwilioIcon />}
      status={config?.id ? "connected" : "disconnected"}
      features={
        config?.id
          ? [{ icon: <PhoneIcon />, label: config.phone_num }]
          : [
              {
                icon: <MessageIcon />,
                label: t({
                  id: "client-support-page.sms-chat-tile-feature-two-way-sms",
                  defaultMessage: "Two-way SMS",
                }),
              },
              {
                icon: <SettingsIcon />,
                label: t({
                  id: "client-support-page.sms-chat-tile-feature-automation",
                  defaultMessage: "SMS automation",
                }),
              },
              {
                icon: <LinkIcon />,
                label: t({
                  id: "client-support-page.sms-chat-tile-feature-link-tracking",
                  defaultMessage: "Short links tracking",
                }),
              },
              {
                icon: <TwilioBrandIcon />,
                label: t({
                  id: "client-support-page.sms-chat-tile-feature-twilio-account",
                  defaultMessage: "Works with Twilio account",
                }),
              },
            ]
      }
    />
  );
};
